import Link from 'next/link';
import { memo } from 'react';

import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { ClockIcon } from '@air/design-icons';
import { Tooltip } from '@air/primitive-tooltip';

import { Routes } from '~/constants/routes';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';

export const SidebarNavigationItemMyUploads = memo(() => {
  const { isActiveRoute } = useIsActiveRoute({ route: Routes.media.myUploads });

  return (
    <Tooltip label="Items uploaded by you" side="right" sideOffset={4}>
      <SidebarNavigationItem
        asChild
        data-id="my-uploads"
        prefix={<ClockIcon size="sm" />}
        state={isActiveRoute ? 'active' : 'default'}
      >
        <Link href={Routes.media.myUploads}>My uploads</Link>
      </SidebarNavigationItem>
    </Tooltip>
  );
});

SidebarNavigationItemMyUploads.displayName = 'SidebarNavigationItemMyUploads';
